import {
  DOCUMENTS_STORE,
  TABS_STORE,
  getDb,
  promisifyRequest,
  promisifyTxn,
} from "./PdfDb";
import type { TabRecord } from "./types";

export async function listTabs(): Promise<TabRecord[]> {
  const db = await getDb();
  const txn = db.transaction(TABS_STORE, "readonly");
  const rows = await promisifyRequest(txn.objectStore(TABS_STORE).getAll());
  return rows.sort((a, b) => a.order - b.order);
}

export async function putTab(record: TabRecord): Promise<void> {
  const db = await getDb();
  const txn = db.transaction(TABS_STORE, "readwrite");
  txn.objectStore(TABS_STORE).put(record);
  await promisifyTxn(txn);
}

export async function deleteTab(id: string): Promise<void> {
  const db = await getDb();
  const txn = db.transaction([TABS_STORE, DOCUMENTS_STORE], "readwrite");
  txn.objectStore(TABS_STORE).delete(id);
  txn.objectStore(DOCUMENTS_STORE).delete(id);
  await promisifyTxn(txn);
}

export async function updateTabOrders(
  updates: Array<{ id: string; order: number }>,
): Promise<void> {
  if (updates.length === 0) return;
  const db = await getDb();
  const txn = db.transaction(TABS_STORE, "readwrite");
  const store = txn.objectStore(TABS_STORE);
  for (const u of updates) {
    const row = (await promisifyRequest(store.get(u.id))) as
      | TabRecord
      | undefined;
    if (!row) continue;
    store.put({ ...row, order: u.order, updatedAt: Date.now() });
  }
  await promisifyTxn(txn);
}
